import {FormikProps} from "formik";
import {CreateInstallmentRateByCourseCreateInput} from "../../../generated/graphql";
import {PossibleFormikPropsType} from "../CourseCreate/CourseCreateForm";

export const updateTotalPrice = (
    rates: Array<CreateInstallmentRateByCourseCreateInput>,
    formikProps: FormikProps<PossibleFormikPropsType>,
) => {
    let totalPrice = 0;

    rates.forEach((r) => {
        if (r.installmentAmount) {
            totalPrice += r.installmentAmount;
        }
    });

    if (formikProps.values.paymentInterval === "PerLesson") {
        totalPrice = totalPrice / formikProps.values.lessons.length;
    }

    formikProps.setFieldValue("fee", totalPrice);

    // update formikProps.values.coursePrice
    const coursePrice = formikProps.values.coursePrice;

    if (coursePrice) {
        coursePrice[0].grossPrice = totalPrice;
    }

    formikProps.setFieldValue("coursePrice", coursePrice);
};
